import { Directive } from '@angular/core';

@Directive({
  selector: '[report-date]'
})
export class ReportDateInputDirective {}
